import React, { useState } from "react";
import ContactPerson from "./ContactPerson";
import CustomerUser, { NewCustomerUser } from "../../../models/CustomerUser";

const CUSTOMER_USERS: CustomerUser[] = [
	{
		id: "1",
		firstName: "Anna",
		lastName: "Andersson",
		email: "anna.andersson@example.com",
		profile: { phoneNumber: "070-123 45 67" },
	},
	{
		id: "2",
		firstName: "Bertil",
		lastName: "Bengtsson",
		email: "bertil.bengtsson@example.com",
		profile: { phoneNumber: "070-765 43 21" },
	},
	{
		id: "3",
		firstName: "Cecilia",
		lastName: "Carlsson",
		email: "cecilia.carlsson@example.com",
		profile: { phoneNumber: "" },
	},
];

const ContactPersonExample: React.FC = () => {
	const [value, setValue] = useState<NewCustomerUser>();

	return (
		<div className="space-y-8 p-6">
			<div>
				<h3 className="mb-4 text-lg font-semibold">ContactPerson Example</h3>

				<div className="max-w-xl space-y-4">
					<ContactPerson value={value} onChange={setValue} customerUsers={CUSTOMER_USERS} />

					<p className="text-sm text-gray-600">
						Value: {value ? `${value.firstName} ${value.lastName} <${value.email}>` : "none"}
					</p>
				</div>
			</div>

			<div>
				<h3 className="mb-4 text-lg font-semibold">Without customer users (picker disabled)</h3>
				<div className="max-w-xl">
					<ContactPerson customerUsers={[]} onChange={() => {}} />
				</div>
			</div>
		</div>
	);
};

export default ContactPersonExample;
